module.exports = __webpack_public_path__ + "img/berekening-voorbeeld.e8b31008.jpg";